import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  id: any;
}

const initialState: AuthState = {
  id: null,
};

const userIdSlice = createSlice({
  name: 'userId',
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    clearUserId: state => {
      state.id = null;
    },
  },
});

export const { setUserId, clearUserId } = userIdSlice.actions;
export default userIdSlice.reducer;
